import { push } from 'connected-react-router';
import get from 'lodash/get';
import { generatePath } from 'utils/generatePath';
import { MENU } from 'menus/constants/entities';
import { getBaseMenuPathForLocation } from 'menus/selectors';
import { closeNotificationModal } from 'base/actions/notificationModals';
import { getItemByIdSelector } from 'base/reducers/bentoApi';
import { isMobileMedia } from 'utils/media';
import { openModal } from 'base/actions/modal';

export const goToOrderSettings = () => (dispatch, getState) => {
  const state = getState();
  const onlineOrderingLocation = state.cart.online_ordering_location;
  const selectedLocation = getItemByIdSelector(
    state.restaurantLocations,
    onlineOrderingLocation
  );

  if (onlineOrderingLocation) {
    const path = generatePath(MENU, 'orderSetting', {
      slug: get(selectedLocation, 'location.slug')
    });

    if (!isMobileMedia()) {
      dispatch(openModal());
    }

    dispatch(closeNotificationModal());
    return dispatch(push(path));
  }
};

export const goToMenu = () => (dispatch, getState) => {
  const state = getState();
  const onlineOrderingLocation = state.cart.online_ordering_location;

  if (onlineOrderingLocation) {
    const path = getBaseMenuPathForLocation(state);
    dispatch(closeNotificationModal());
    return dispatch(push(path));
  }
};
